
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as AtlasAppIconComponent } from "./atlas-app-icon.svg";

export const AtlasAppIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <AtlasAppIconComponent {...props} />;
};
